import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Preset } from '../../../data/preset';
import { ColumnForEdit } from '../../../data/column-for-edit';
import { AdminPanelService } from '../../../data/admin-panel.service';
import {ConfirmationService} from 'primeng/api';
import {PresetService} from '../../../data/preset.service';

@Component({
  selector: 'app-kb-preset-editor-dialog',
  templateUrl: './kb-preset-editor-dialog.component.html',
  styleUrls: ['./kb-preset-editor-dialog.component.scss'],
  providers: [ConfirmationService]
})
export class KbPresetEditorDialogComponent implements OnInit {
  preset: Preset;
  allColumns: ColumnForEdit[] = [];

  columnsSelection: {column: ColumnForEdit, selected: boolean}[] = [];

  constructor(
    public dialogRef: MatDialogRef<KbPresetEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { preset: Preset, allColumns: ColumnForEdit[] },
    private adminPanelService: AdminPanelService,
    private confirmationService: ConfirmationService,
    private presetService: PresetService
  ) {
    this.preset = data.preset ? { ...data.preset } : new Preset();
    this.allColumns = data.allColumns;
  }

  ngOnInit(): void {
    if (!this.preset.columnsId) {
      this.preset.columnsId = [];
    }

    this.columnsSelection = this.allColumns.map(col => ({
      column: col,
      selected: this.preset.columnsId.includes(col.id)
    }));
  }

  save() {
    this.preset.columnsId = this.columnsSelection
      .filter(item => item.selected)
      .map(item => item.column.id);

    if (this.preset.id) {
      this.presetService.updatePreset(this.preset).subscribe(res => {
        this.dialogRef.close(res);
      });
    } else {
      this.presetService.createPreset(this.preset).subscribe(res => {
        this.dialogRef.close(res);
      });
    }
  }

  delete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this preset?',
      accept: () => {
        if (this.preset.id) {
          this.presetService.deletePreset(this.preset.id).subscribe(() => {
            this.dialogRef.close(true);
          });
        } else {
          this.dialogRef.close();
        }
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}

